import { StateService } from "@uirouter/angularjs";
import { RecordDataSource } from "../../../../../records/grids";
import { ColDef } from "../../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../../../../records/grids/controller";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../records/server/query";
import { ProgressiveDefinition } from "../../../models/progressiveDefinition";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../../records/views/recordGridView";
import { vsObjectName as progressiveDefinitionName } from "../../../config/progressiveDefinition";
const colId = Symbol("main.machines.progressives.grid");
export class ProgressivesGridComponentController {
  static $inject = [
    RecordGridViewServiceName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    "$state",
  ];

  private readonly gridDataSource: RecordDataSource;
  private readonly gridSettings: IGridSettings;
  private readonly columns: ColDef[];
  private readonly defaultQuery: IQuery = {};
  private readonly defaultSort: string = "";

  constructor(
    recordGridViewService: RecordGridViewService,
    gridSettingService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly $state: StateService
  ) {
    const gridConfiguration = recordGridViewService.getGridConfiguration(
      progressiveDefinitionName
    )!;

    this.gridDataSource = gridConfiguration.gridDataSource!;
    this.gridSettings = gridSettingService.getGridSettings(colId);
    this.defaultSort = gridConfiguration.defaultSort!;
    this.columns = [
      columnDefinitionService.getLinkColDef({
        colId: "detail",
        headerName: "detail",
        iconClass: "fa fa-info-circle text-primary",
        stateExpression:
          ".detail.machines({ progressiveDefinitionId: data.Id})",
        width: 20,
      }),
      columnDefinitionService.getLinkColDef({
        headerName: "edit",
        iconClass: "fa fa-pencil text-primary",
        colId: "edit",
        width: 20,
        stateExpression: ".detail.edit({ progressiveDefinitionId: data.Id })",
      }),
      ...(gridConfiguration.columns ?? []),
    ];
  }
}
